/*
 * @Author: liym35984
 * @Date: 2021-12-09 23:05:21
 * @LastEditors: liym35984
 * @LastEditTime: 2022-03-29 15:52:50
 * @FilePath: \openplat-web-documentcenter\src\api\frontDoc\api.js
 */
import fetch from "@/api/httpFetch.js";
const url = '/openplat-provider-server/v'
const url1 = '/openplat-documentcenter-server/v'
const modelName = window.LOCAL_CONFIG.API_HOME_DOC;
// 获取api 详情信息
export function getDetail (data) {
  return fetch.post(url + `/getApiDetailInfoDoc`, data);
}

// 获取api分组列表
export function getServieDetailApiGroups (data) {
  return fetch.post(url + `/getServieDetailApiGroups`, data)
  // .then((res) => {
  
  //   return {
  //     api_Infos:[{
  //       api_group_id:'1',
  //       api_id:'2',
  //       api_name:'xxx'
  //     },{
  //       api_group_id:'1',
  //       api_id:'2',
  //       api_name:'xxx'
  //     },{
  //       api_group_id:'1',
  //       api_id:'2',
  //       api_name:'xxx'
  //     }]
  //   }
  // }).catch(catchError=>{
  //   console.error('网络异常')
  // })
}
// 获取字典项信息
export function getSearchSubEntryDoc (data) {
  return fetch.post(url + `/getSearchSubEntryDoc`, data);
}

// 在线测试
export function onlineTest (data) {
  return fetch.post(url1 + `/onlineAPITest/onlineTest`, data);
}





// WEBPACK FOOTER //
// ./src/gtn/api/frontDoc/api.js